import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { Box, Typography, useTheme } from '@mui/material';

const positionLabels = {
    1: 'Portero',
    2: 'Defensa',
    3: 'Medio',
    4: 'Delantero',
    5: 'Delantero',
};

const JugadorPartidosGrid = ({ player }) => {
    const theme = useTheme();
    const image = `${process.env.NEXT_PUBLIC_IMAGES}/estadio/estadio.jpg`;
    const grids = player?.p?.map((partido) => partido.gr).filter(Boolean);

    if (!grids || grids.length === 0) {
        return null;
    }

    // Contamos cuántas veces aparece cada grid
    const gridCounts = grids.reduce((acc, grid) => {
        acc[grid] = (acc[grid] || 0) + 1;
        return acc;
    }, {});

    // Agrupar posiciones por tipo (Defensa, Medio, etc.)
    const groupedPositions = Object.entries(gridCounts).reduce((acc, [grid, count]) => {
        const row = parseInt(grid.split(':')[0], 10);
        const positionName = positionLabels[row] || `Posición ${grid}`;

        if (!acc[positionName]) acc[positionName] = 0;
        acc[positionName] += count;

        return acc;
    }, {});

    const getBottomAndLeft = (row, col) => {
        const defenseMidPositions = [0, 5, 25, 50, 75, 95, 95];
        const midPositions = [0, 20, 50, 80];
        const delanteroPositions = [25, 50, 75];
        if (row === 1) {
            return {
                bottom: '50px',
                left: `${50}%`,
            };
        } else if (row === 2) {
            const left = defenseMidPositions[col] ?? 50;
            return {
                bottom: '100px',
                left: `${left}%`,
            };
        } else if (row === 3) {
            const left = midPositions[col] ?? 80;
            return {
                bottom: '280px',
                left: `${left}%`,
            };
        } else {
            const left = delanteroPositions[col] ?? 50;
            return {
                bottom: '380px',
                left: `${left}%`,
            };
        }
    };

    return (
        <CustomSectionWrapper color="accent" title="Partidos por posiciones">
            {Object.entries(groupedPositions).map(([position, count]) => (
                <Typography key={position} fontSize={12} display={'flex'} justifyContent={'flex-end'}>
                    {position}: {count} partidos
                </Typography>
            ))}
            {/* Campo de fútbol */}
            <Box
                sx={{
                    position: 'relative',
                    backgroundImage: `url(${image})`,
                    backgroundSize: '100% 100%',
                    width: '100%',
                    height: '500px',
                    borderRadius: 0.5,
                    overflow: 'hidden',
                }}
            >
                {/* Renderiza los puntos en sus posiciones */}
                {Object.entries(gridCounts).map(([grid, count]) => {
                    const [row, col] = grid.split(':').map(Number);

                    const { bottom, left } = getBottomAndLeft(row, col);
                    const width = 8 + count * 2;

                    return (
                        <Box
                            key={grid}
                            sx={{
                                position: 'absolute',
                                bottom: bottom,
                                left: left,
                                transform: 'translate(-50%, -50%)',
                                width: `${width}px`,
                                height: `${width}px`,
                                backgroundColor: theme.palette.background.card,
                                borderRadius: '50%',
                                border: `2px solid ${theme.palette.border.main}`,
                            }}
                        ></Box>
                    );
                })}
            </Box>
        </CustomSectionWrapper>
    );
};

export default JugadorPartidosGrid;
